import { ExternalTicketProvisionerConfigRef, ExternalTicketRef } from 'pbts/c1/api/external_tickets/v1/external_tickets'
import { ExternalTicketsClient } from 'pbts/c1/api/external_tickets/v1/external_tickets.client'

import { createMutationApi } from './lib/createMutationApi'
import { createPagedListApi } from './lib/createPagedListApi'
import { createUnaryApi } from './lib/createUnaryApi'

export const ListConnectorExternalTicketProvisionersApi = createPagedListApi(
    ExternalTicketsClient,
    'listConnectorExternalTicketProvisioner',
)

export const CreateExternalTicketProvisionerConfigApi = createMutationApi(
    ExternalTicketsClient,
    'createExternalTicketProvisionerConfig',
)

export const ListExternalTicketProvisionerConfigsApi = createPagedListApi(
    ExternalTicketsClient,
    'listExternalTicketProvisionerConfig',
    undefined,
    ExternalTicketProvisionerConfigRef.typeName,
)

export const GetExternalTicketProvisionerConfigApi = createUnaryApi(
    ExternalTicketsClient,
    'getExternalTicketProvisionerConfig',
    undefined,
    ExternalTicketProvisionerConfigRef.typeName,
)

export const GetConnectorExternalTicketProvisionerApi = createUnaryApi(
    ExternalTicketsClient,
    'getConnectorExternalTicketProvisioner',
)

export const UpdateExternalTicketProvisionerConfigApi = createMutationApi(
    ExternalTicketsClient,
    'updateExternalTicketProvisionerConfig',
    undefined,
    ExternalTicketProvisionerConfigRef.typeName,
)

export const DeleteExternalTicketProvisionerConfigApi = createMutationApi(
    ExternalTicketsClient,
    'deleteExternalTicketProvisionerConfig',
)

export const GetExternalTicketApi = createUnaryApi(
    ExternalTicketsClient,
    'getExternalTicket',
    undefined,
    ExternalTicketRef.typeName,
)

export const ProcessExternalTicketForBulkActionApi = createMutationApi(
    ExternalTicketsClient,
    'processExternalTicketForBulkAction',
)
